export function formatFileSize(bytes) {
  if (bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = (bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1);
  return size + ' ' + units[i];
}

export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function showToast(message, type) {
  type = type || 'info';
  const existing = document.querySelector('.toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.className = 'toast ' + type;
  toast.textContent = message;
  document.body.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transition = 'opacity 0.3s ease';
    setTimeout(() => toast.remove(), 300);
  }, 4000);
}

export function debounce(fn, delay) {
  delay = delay || 300;
  let timer;
  return function() {
    var args = arguments;
    var ctx = this;
    clearTimeout(timer);
    timer = setTimeout(function() { fn.apply(ctx, args); }, delay);
  };
}

export function inchesToPixels(inches, dpi) {
  return Math.round(inches * dpi);
}

export function mmToPixels(mm, dpi) {
  return Math.round((mm / 25.4) * dpi);
}

export function pixelsToInches(px, dpi) {
  return px / dpi;
}

export function pixelsToMm(px, dpi) {
  return (px / dpi) * 25.4;
}
